import React from 'react';

import { useAccount } from '../../hooks/useAccounts';

const AccountLink = ({ accountId }) => {
  const { data: account, isLoading } = useAccount({ accountId });

  const displayName = isLoading || !account?.name ? accountId : account.name;

  // Fix: URL-encode the accountId to prevent URL manipulation and injection attacks
  const safeAccountId = encodeURIComponent(accountId);

  return (
    <a href={`https://accounts.cimpress.io/${safeAccountId}`} target="_blank" rel="noopener noreferrer">
      {displayName}
    </a>
  );
};

export default AccountLink;
